<template>
    <div class="content">
        <div class="header">
            <div class="text">权益介绍演示工具</div>
            <div class="addLawyer">
                <veui-button
                    ui="primary xl"
                    @click="handleModalOpen"
                >
                    <veui-icon
                        class="add-icon"
                        name="plus"
                    />
                    创建演示
                </veui-button>
            </div>
        </div>
        <div class="search-section">
            <veui-form
                ref="searchForm"
                :data="searchFormData"
            >
                <veui-field label="客户名" class="search-input">
                    <veui-input
                        v-model="searchFormData.name"
                        placeholder="请输入姓名"
                    />
                </veui-field>
                <veui-field
                    v-if="!isAgentSubAccount"
                    label="销售成员"
                    class="sales-name-input"
                >
                    <veui-select
                        v-model="searchFormData.salesNameId"
                        class="option"
                        placeholder="请选择"
                        data-stat-ignore
                        :options="filterMemberList"
                        searchable
                    >
                    </veui-select>
                </veui-field>
                <template>
                    <veui-button
                        ui="primary l"
                        type="submit"
                        @click="searchHandleSubmit"
                    >查询</veui-button>
                </template>
            </veui-form>
        </div>
        <div
            v-if="!isAgentSubAccount"
            class="transfer-all"
        >
            <div class="btn" @click="handleTransfer">批量变更销售</div>
        </div>
        <div :class="{table: true, initial: pn === 1 ? true : false}">
            <veui-table
                :data="lawyerList"
                :order="order"
                :order-by="orderBy"
                :loading="isLoading"
                @sort="handleSort"
            >
                <veui-table-column
                    field="no"
                    title="序号"
                    width="75"
                >
                    <template #default="{no}">
                        {{ no ? no : '默认' }}
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="name"
                    title="姓名"
                    width="110"
                    tooltip
                />
                <veui-table-column
                    field="law_firm_name"
                    title="律所名称"
                    width="260"
                    tooltip
                >
                </veui-table-column>
                <veui-table-column
                    field="lawyer_expert_areas"
                    title="擅长领域"
                    width="260"
                    tooltip
                >
                    <template #default="{lawyer_expert_areas}">
                        <div>{{ lawyer_expert_areas && lawyer_expert_areas.join('、') }}</div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="create_time"
                    title="创建时间"
                    width="120"
                    sortable
                >
                    <template #default="{create_time}">
                        <div>{{ create_time && formatData(create_time) }}</div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="firm_subaccount_name"
                    title="关联销售人员"
                    width="120"
                >
                </veui-table-column>
                <veui-table-column
                    field="operation"
                    title="操作"
                    width="260"
                    fixed="right"
                >
                    <template #default="data">
                        <div>
                            <veui-button
                                ui="text"
                                @click="transform(data.id, data.firm_id)"
                            >
                                生成链接
                            </veui-button>
                            <veui-button
                                v-if="!isAgentSubAccount"
                                ui="text"
                                @click="openTransferCustomerDialog(data)"
                            >
                                变更销售
                            </veui-button>
                            <veui-button
                                ui="text"
                                @click="edit(data)"
                            >
                                编辑
                            </veui-button>
                            <veui-button
                                :ref="`${data.id}toggle`"
                                ui="text"
                                @click="deleteLawyer(data.id)"
                            >
                                删除
                            </veui-button>
                            <veui-overlay
                                :target="`${id}toggle`"
                                position="top-start"
                                :open.sync="deleteOpen"
                                overlay-class="relative-overlay"
                            >
                                <div>
                                    <div class="title">是否删除</div>
                                    <div class="overlay-foot">
                                        <veui-button ui="strong" @click="deleteOpen = false">
                                            取消
                                        </veui-button>
                                        <veui-button ui="primary" @click="confirm">
                                            确认
                                        </veui-button>
                                    </div>
                                </div>
                            </veui-overlay>
                        </div>
                    </template>
                </veui-table-column>
            </veui-table>
            <div v-if="isNoMoreResult" class="no-result">
                <div class="icon"></div>
                <div class="text">暂无律师信息，快去添加吧~</div>
            </div>
        </div>
        <!-- 右侧抽屉 -->
        <veui-drawer
            overlay-class="right-drawer"
            :title="isEdit ? '编辑律师' : '添加律师'"
            :open.sync="modalOpen"
            outside-closable
            @ok="handleModalClose(true)"
        >
            <template #default>
                <veui-form
                    ref="drawerForm"
                    :data="drawerFormData"
                    :validators="validators"
                >
                    <div class="form-title">律师信息</div>
                    <veui-field
                        id="name"
                        label="姓名"
                        name="name"
                        field="name"
                        :rules="[{name: 'required', message: '请输入律师姓名'}]"
                    >
                        <veui-input
                            v-model="drawerFormData.name"
                            placeholder="请输入律师姓名"
                        />
                    </veui-field>
                    <veui-field
                        id="lawyer_city"
                        label="城市"
                        field="lawyer_city"
                        :rules="[{name: 'required', message: '请选择律师城市'}]"
                    >
                        <citySelect
                            :city="drawerFormData.lawyer_city"
                            type="2"
                            placeholder="请选择律师城市"
                            @cityChange="cityChange"
                        />
                    </veui-field>
                    <veui-field
                        id="law_firm_name"
                        label="律所名称"
                        field="law_firm_name"
                        :rules="[{name: 'required', message: '请输入律所名称'}]"
                    >
                        <veui-input
                            v-model="drawerFormData.law_firm_name"
                            placeholder="请输入律所名称"
                        />
                    </veui-field>
                    <veui-field
                        id="lawyer_expert_areas"
                        label="擅长领域"
                        data-stat-ignore
                        field="lawyer_expert_areas"
                        :rules="[{name: 'required', message: '请选择擅长领域'}]"
                    >
                        <veui-select
                            v-model="drawerFormData.lawyer_expert_areas"
                            data-stat-ignore
                            clearable
                            multiple
                            overlay-class="domain-select"
                            placeholder="请选择擅长领域"
                            :max="maxDomainNum"
                        >
                            <veui-option-group
                                v-for="(item, index) in domainOption"
                                :key="index"
                                :label="item.name"
                                position="popup"
                                overlay-class="domain-option"
                            >
                                <veui-option
                                    v-for="item in item.children"
                                    :key="item.id"
                                    :value="item.name"
                                    :label="item.name"
                                />
                            </veui-option-group>
                        </veui-select>
                    </veui-field>
                    <veui-field
                        name="lawyer_avatar"
                        field="lawyer_avatar"
                        label="律师头像"
                    >
                        <cropper-avator
                            item="case_pic"
                            field="case_pic"
                            :is-cropped="true"
                            :url="`${url}&bucketName=law_smart&storeDir=honorary_licence&ajax=true`"
                            :is-not-essential="true"
                            :img-src="drawerFormData.lawyer_avatar ? drawerFormData.lawyer_avatar : ''"
                            @upload-suc="uploadSuc"
                        >
                        </cropper-avator>
                    </veui-field>
                    <div class="form-title">代理商信息</div>
                    <veui-field
                        label="代理商姓名"
                        name="firm_name"
                        field="firm_name"
                        :rules="[{name: 'required', message: '请输入代理商姓名'}]"
                    >
                        <veui-input
                            v-model="drawerFormData.firm_name"
                            placeholder="请输入代理商姓名"
                        />
                    </veui-field>
                    <veui-field
                        label="代理商电话"
                        name="firm_mobile_number"
                        field="firm_mobile_number"
                        required
                    >
                        <veui-input
                            v-model="drawerFormData.firm_mobile_number"
                            placeholder="请输入代理商电话"
                        />
                    </veui-field>
                    <veui-field
                        name="firm_avatar"
                        field="firm_avatar"
                        label="代理商头像"
                    >
                        <cropper-avator
                            item="agent_pic"
                            field="agent_pic"
                            :is-cropped="true"
                            :url="`${url}&bucketName=law_smart&storeDir=honorary_licence&ajax=true`"
                            :is-not-essential="true"
                            :img-src="drawerFormData.firm_avatar ? drawerFormData.firm_avatar : ''"
                            @upload-suc="uploadSuc"
                        >
                        </cropper-avator>
                    </veui-field>
                </veui-form>
            </template>
            <template #foot>
                <veui-button
                    class="copy"
                    ui="primary l"
                    type="submit"
                    @click="drawerHandleSubmit"
                >{{ `${isEdit ? '确认' : '添加'}并复制转发链接` }}</veui-button>
            </template>
        </veui-drawer>
        <!-- 分页器 -->
        <veui-pagination
            v-if="lawyerList && lawyerList.length && !isNoMoreResult"
            :page="pn"
            :page-size="rn"
            :total="count"
            class="pagination"
            @redirect="pageChange"
        />
        <!-- 转移客户 -->
        <transfer-customer
            v-if="isShowTransferCustomerDialog"
            :open="isShowTransferCustomerDialog"
            :info="detailData"
            :trans-type="3"
            @updateList="getList"
            @close="updateTransferCustomerDialog"
        />
    </div>
</template>

<script>
import {
    Form,
    Field,
    Input,
    Button,
    Table,
    Column,
    Pagination,
    Drawer,
    Select,
    OptionGroup,
    Option,
    Icon,
    Overlay
} from 'veui';
import 'veui-theme-dls-icons';
import toast from 'veui/plugins/toast';
import Vue from 'vue';
import cropperAvator from '../../material/views/cropper-avator.vue';
import {isBoolean} from 'lodash';
import dayjs from 'dayjs';
import citySelect from '@/components/citySelect.vue';
import transferCustomer from '@/components/firm/transfer-customer.vue';
import {mapState} from 'vuex';

Vue.use(toast);

const url = {
    domain: '/bp/api/lawyer/get_lawyer_domain',
    list: '/bp/firmlawyer/getlawyerinfolist',
    update: '/bp/firmlawyer/updatefirmhaslawyer',
    add: '/bp/firmlawyer/createfirmhaslawyer',
    delete: '/bp/firmlawyer/deletefirmhaslawyer'
};

export default {
    name: 'vipBenefitTool',
    components: {
        'veui-icon': Icon,
        'veui-form': Form,
        'veui-field': Field,
        'veui-input': Input,
        'veui-button': Button,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-pagination': Pagination,
        'veui-drawer': Drawer,
        'veui-option-group': OptionGroup,
        'veui-option': Option,
        'veui-select': Select,
        'cropper-avator': cropperAvator,
        'veui-overlay': Overlay,
        'transfer-customer': transferCustomer,
        citySelect
    },
    data() {
        return {
            url: '/bp/api/upload?ajax=1&bdstoken=',
            searchFormData: {
                name: '',
                // 默认全部
                salesNameId: -1
            },
            drawerFormData: {
                name: '', // 律师姓名
                law_firm_name: '', // 律所名称
                lawyer_expert_areas: null, // 擅长领域
                lawyer_avatar: '', // 律师头像
                lawyer_mobile_number: '', // 律师手机号码
                firm_name: '', // 代理商姓名
                firm_avatar: '', // 代理商头像
                firm_mobile_number: '', // 代理商手机号码
                lawyer_city: []
            },
            lawyerList: [],
            pn: 1, // 当前页
            rn: 10, // 每页数据数量
            count: 0, // table表格数据总数
            // 是否打开右侧新建律师抽屉
            modalOpen: false,
            // 是否删除二次气泡确认
            deleteOpen: false,
            // 用于指定当前基于哪一列进行了排序，值必须来自内部某个 Column 组件的 field 属性
            orderBy: '',
            // 排序顺序。为 false 时表示无序，为字符串值 'asc' / 'desc' 时分别为升序/降序。
            order: '',
            // 创建时间排序：0：不排序 1：正序 2：倒序
            orderCreateTime: '2',
            domainOption: [], // 擅长领域
            maxDomainNum: 6, // 最多显示多少个擅长领域
            isEdit: false, // 是否为点击列表编辑按钮进入的添加律师modal
            id: '', // 律师id，用于判断编辑按钮选择的律师
            isNoMoreResult: false, // 搜索结果是否为空
            isLoading: false, // 表格loading态
            validators: [
                {
                    fields: ['firm_mobile_number'],
                    handler(phone) {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                let res;
                                let reg = /^(((\d{3,4}-)?\d{7,8})|(1(3|4|5|6|7|8|9)\d{9}))$/;
                                if (!reg.test(phone)) {
                                    res = {
                                        firm_mobile_number: '请填写正确的手机号或座机号'
                                    };
                                }
                                resolve(res);
                            });
                        });
                    },
                    triggers: ['submit']
                }
            ],
            isModifyCity: false, // 编辑已有律师表单是否修改了城市,
            origin_city: {},
            isShowTransferCustomerDialog: false, // 转移客户弹窗
            detailData: {}
        };
    },
    computed: {
        ...mapState({
            isAgentSubAccount: state => +state.lawStore.userInfoNew.user_role === 3,
            agentMemberData: state => state.lawStore.agentMemberData,
            userInfoNew: state => state.lawStore.userInfoNew
        }),
        filterMemberList() {
            let agentMemberData = this.agentMemberData || [];
            agentMemberData.forEach(item => {
                item.label = item.name;
                item.value = item.id;
            });
            return [
                {
                    label: '全部',
                    value: -1
                },
                {
                    label: '未关联',
                    value: 0
                },
                ...agentMemberData
            ];
        }
    },
    watch: {
        modalOpen: function (flag) {
            // 初始化擅长领域 options
            if (flag) {
                this.getDomain();
                this.$wywLog.send({
                    area: 'tj',
                    action: 'show'
                });
            }
            else {
                this.drawerFormData = {};
                this.$wywLog.send({
                    area: 'tj-ls-fanhui',
                    action: 'click'
                });
            }
        }
    },
    mounted() {
        document.body.classList.add('benefit-tool');
        this.getList();
        this.$wywLog.addKey({
            page: 'vipBenefitTool',
            serverId: 17302
        });
        this.$wywLog.send({
            area: 'xxgl',
            action: 'show'
        });
    },
    destroyed() {
        document.body.classList.remove('benefit-tool');
    },
    methods: {
        // 查询律师
        searchHandleSubmit() {
            this.$refs.searchForm.validate().then(flag => {
                this.$wywLog.send({
                    area: 'xxgl-chaxun',
                    action: 'click'
                });
                this.pn = 1;
                this.getList(true);
            });
        },
        // 右侧添加律师提交并复制
        drawerHandleSubmit() {
            this.$refs.drawerForm.validate().then(flag => {
                this.$wywLog.send({
                    area: 'tj-ls-tianjia',
                    action: 'click'
                });
                if (!isBoolean(flag)) {
                    this.$toast.error('请先完成必填内容~');
                    this.$wywLog.send({
                        area: 'tj-ls-shibai',
                        action: 'click'
                    });
                    return;
                }
                this.submit();
            });
        },
        // 复制
        getCopyText(id, firm_id) {
            const input = document.createElement('input');
            input.style.cssText = 'opacity: 0';
            input.type = 'text';
            input.value = `https://lvlin.baidu.com/pages/member/index?id=${id}&firm_id=${firm_id}`; // 修改文本框的内容
            document.body.appendChild(input);
            input.select(); // 选中文本
            document.execCommand('copy'); // 执行浏览器复制命令
            input.remove(); // 移除input框
        },
        // 传参判断是否为编辑页面进入
        submit() {
            const current_city = this.drawerFormData.lawyer_city || [];
            let params = {
                ...this.drawerFormData,
                /**
                 * 提交涉及编辑律师以及新增律师两种情况，编辑时需要传id，且编辑的时候需要进行表单数据的回显
                 * 因城市选择框进行回显数据改变了原有的v-model数据结构，故定义origin_city，用于储存原始数据
                 */
                ...this.isModifyCity ? {
                    lawyer_city: current_city[1] && current_city[1].label,
                    lawyer_prov_code: current_city[0] && current_city[0].value,
                    lawyer_city_code: current_city[1] && current_city[1].value
                } : {
                    lawyer_city: this.origin_city.lawyer_city,
                    lawyer_prov_code: this.origin_city.lawyer_prov_code,
                    lawyer_city_code: this.origin_city.lawyer_city_code
                },
                lawyer_expert_areas: this.drawerFormData.lawyer_expert_areas.join('$')
            };
            if (this.isEdit) {
                params = Object.assign(params, {id: this.id});
            }
            const URL = this.isEdit ? url.update : url.add;
            this.$http.post(URL, {
                ...params
            }).then(res => {
                res = this.$normalizeResponseData(res);
                this.drawerFormData = {};
                this.getCopyText(res.id, res.firm_id);
                this.$toast.success('操作成功，可将链接发送至客户~');
                this.getList();
                this.modalOpen = false;
            }).catch(err => {
                this.$wywLog.send({
                    area: 'tj-ls-shibai',
                    action: 'click'
                });
            });
        },
        // 转发
        transform(id, firm_id) {
            this.getCopyText(id, firm_id);
            this.$wywLog.send({
                area: 'xxgl-shengcheng',
                action: 'click'
            });
            this.$toast('已生成分享链接，可发送至律师~');
        },
        // 删除
        deleteLawyer(id) {
            this.$wywLog.send({
                area: 'xxgl-shanchu',
                action: 'click'
            });
            if (id === 0) {
                this.$toast.error('默认律师不允许删除~');
                return;
            }
            this.id = id;
            this.deleteOpen = true;
        },
        confirm() {
            this.deleteOpen = false;
            this.$http.post(url.delete, {
                id: this.id
            }).then(res => {
                if (this.count % 10 === 1 && this.pn > 1) {
                    this.pn--;
                }
                this.$toast.success('删除成功~');
                this.getList();
            }).catch(err => {
                this.$normalizeResponseError(err);
            });
        },
        edit(data) {
            this.$wywLog.send({
                area: 'xxgl-bianji',
                action: 'click'
            });
            if (data.id === 0) {
                this.$toast.error('默认律师不允许编辑~');
                return;
            }
            this.origin_city = {
                lawyer_city: data.lawyer_city,
                lawyer_city_code: data.lawyer_city_code,
                lawyer_prov_code: data.lawyer_prov_code
            };
            // 表单数据回显赋值
            this.drawerFormData = {
                name: data.name,
                law_firm_name: data.law_firm_name,
                lawyer_expert_areas: data.lawyer_expert_areas,
                lawyer_avatar: data.lawyer_avatar,
                firm_name: data.firm_name,
                firm_avatar: data.firm_avatar,
                firm_mobile_number: data.firm_mobile_number,
                lawyer_city: [Number(data.lawyer_prov_code), Number(data.lawyer_city_code)]
            };
            this.id = data.id;
            this.isEdit = true;
            this.modalOpen = true;
            this.isModifyCity = false;
        },
        pageChange(pn) {
            this.pn = pn;
            this.getList();
        },
        handleModalClose(ok) {
            this.modalOpen = false;
        },
        handleModalOpen() {
            this.$wywLog.send({
                area: 'xxgl-tianjia',
                action: 'click'
            });
            // 代理商-子角色
            if (this.isAgentSubAccount) {
                let {law_firm_subaccount = {}} = this.userInfoNew;
                // 表单数据-默认值
                this.drawerFormData = {
                    firm_name: law_firm_subaccount?.name || '',
                    firm_avatar: '',
                    firm_mobile_number: law_firm_subaccount.phone || ''
                };
            }
            this.modalOpen = true;
            this.isEdit = false;
        },
        // 排序处理
        handleSort(field, order) {
            this.order = order;
            this.orderBy = field;
            const orderObj = {
                asc: '1',
                desc: '2'
            };
            // 默认排序就是降序，所以不存在 orderCreateTime 为0的情况
            this.orderCreateTime = order ? orderObj[order] : '2';
            this.getList();
        },
        // 获取列表
        getList(isSearch = false) {
            this.isLoading = true;
            const params = {
                pn: this.pn,
                rn: this.rn,
                orderCreateTime: this.orderCreateTime,
                ...this.searchFormData.name && {
                    name: this.searchFormData.name
                },
                firm_subaccount_id: this.searchFormData.salesNameId
            };
            this.$http.get(url.list, {
                params
            }).then(res => {
                this.isLoading = false;
                res = this.$normalizeResponseData(res);
                if (res.count === 0) {
                    this.isNoMoreResult = true;
                    // 接口返回兜底律师数据
                    this.lawyerList = res?.list || [];
                }
                else {
                    this.count = res?.count;
                    this.lawyerList = res?.list || [];
                    this.isNoMoreResult = false;
                    // 前端对列表序号进行展示添加
                    this.lawyerList = this.lawyerList.map((item, index) => {
                        // 判断this.pn是否为1是因为返回list数组存在兜底律师数据
                        return {
                            ...item,
                            no: this.pn === 1 ? 10 * (this.pn - 1) + index : 10 * (this.pn - 1) + index + 1
                        };
                    });
                }
                if (isSearch) {
                    this.$toast.success('查询成功~');
                }
            }).catch(err => {
                this.isLoading = false;
                this.$normalizeResponseError(err);
            });
        },
        // 获取擅长领域 options
        getDomain() {
            this.$http.get(url.domain, {
            }).then(res => {
                res = this.$normalizeResponseData(res);
                if (res) {
                    let data =  res;
                    this.domainOption = data;
                }
            });
        },
        // 日期格式化
        formatData(date) {
            if (date) {
                return dayjs(date).format('YYYY-MM-DD HH:mm');
            }
            return '';
        },
        // 图片数据上传 case_pic : 律师头像 agent_pic : 代理商头像 律师头像未上传由后端处理默认兜底展示头像
        uploadSuc(item, url) {
            switch (item) {
                case 'case_pic':
                    this.drawerFormData = {
                        ...this.drawerFormData,
                        lawyer_avatar: url
                    };
                    break;
                case 'agent_pic':
                    this.drawerFormData = {
                        ...this.drawerFormData,
                        firm_avatar: url
                    };
                    break;
                default:
                    break;
            }
        },
        /**
         * 城市筛选过改变时
         * @param {Object} data 选中城市数据
         */

        cityChange(data = {}) {
            let {selectedData} = data;
            this.drawerFormData.lawyer_city = selectedData;
            // 进行修改城市
            this.isModifyCity = true;
        },

        /**
         * 更新转移客户弹窗
         */

        updateTransferCustomerDialog() {
            this.isShowTransferCustomerDialog = !this.isShowTransferCustomerDialog;
        },

        /**
         * 批量转移客户
         */

        handleTransfer() {
            this.detailData = {};
            this.updateTransferCustomerDialog();
        },

        /**
         * 转移客户
         * @param {numebr} data
         */

        openTransferCustomerDialog(data) {
            if (data.id === 0) {
                this.$toast.error('默认律师不允许转移~');
                return;
            }
            this.detailData = data;
            this.updateTransferCustomerDialog();
        }
    }
};
</script>

<style lang="less" scoped>
.content {
    background: #fff;
    box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
    border-radius: 8px;
    padding: 30px 30px 20px;
    position: relative;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        position: relative;

        .text {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            font-weight: 500;
            color: #000;
            line-height: 18px;
        }

        .addLawyer {
            display: flex;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            font-weight: 400;
            color: #333;
            line-height: 14px;

            &:hover {
                cursor: pointer;
            }

            .add-icon {
                width: 12px;
                height: 12px;
                margin-right: 3px;
                color: #fff;
            }
        }
    }

    .no-result {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 30px;

        .icon {
            height: 180px;
            width: 200px;
            background: url("https:/lvlin-base.cdn.bcebos.com/bend/no-data.png") no-repeat center center;
            background-size: cover;
        }

        .text {
            margin-top: 15px;
            font-size: 16px;
            line-height: 16px;
        }
    }

    .search-section {
        margin-bottom: 10px;

        .veui-form {
            width: 100%;
            display: flex;
            align-items: center;
            height: 40px;
        }

        .search-input,
        .sales-name-input {
            height: 40px;

            /deep/.veui-field-label {
                display: flex;
                width: 42px;
                height: 40px;
                justify-content: flex-start;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                line-height: 14px;
                color: #1e1f24;
                margin-right: 12px;
            }

            /deep/.veui-input,
            /deep/.veui-select {
                width: 220px;
                height: 40px;
            }
        }

        .sales-name-input {
            margin-left: 24px;

            /deep/.veui-field-label {
                width: 58px;
            }
        }

        .veui-button {
            margin-left: 24px;
            width: 80px;
            height: 40px;
            background-color: #05f;
        }
    }

    .transfer-all {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 10px;

        .btn {
            cursor: pointer;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #05f;
            line-height: 16px;
            font-weight: 400;
        }
    }

    .table {
        /deep/.veui-table {
            th {
                height: 54px;
            }

            .veui-table-cell {
                justify-content: center;

                .veui-table-cell-content {
                    .veui-button {
                        color: #05f;
                    }
                }
            }
        }

        /deep/.veui-table-fixed-header {
            .veui-table-cell-content {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                line-height: 14px;
                color: #999;
            }
        }

        /deep/.veui-table [role="cell"] {
            padding: 0 16px;
            height: 54px;
        }

        /deep/.veui-table [role="columnheader"] {
            padding: 0 16px;
            background-color: #f6f8f9;
            border-radius: 2px 2px 0 0;
            border-color: #fff;
        }

        /deep/.veui-table-cell-first {
            padding-left: 24px !important;
        }

        /deep/.veui-table-cell-last {
            .veui-button:nth-child(-n + 2)::after {
                content: "|";
                position: relative;
                left: 7px;
                top: 7px;
                color: #eee;
            }
        }
    }

    .initial {
        /deep/.veui-table-main {
            tr:nth-child(1) {
                td {
                    background-color: #f1f1f1;
                }
            }
        }
    }

    .pagination {
        float: right;
        padding: 30px 0;
    }
}

.right-drawer {
    /deep/.veui-dialog-content {
        width: 488px !important;

        .veui-field-messages {
            padding-top: 1px;
        }

        .veui-dialog-content-head {
            padding-top: 44px;
            padding-left: 28px;

            .veui-dialog-content-head-title {
                font-family: PingFangSC-Medium;
            }
        }

        .veui-dialog-content-body {
            padding-top: 18px;
            padding-left: 28px;

            .form-title {
                font-family: PingFangSC-Medium;
                font-size: 16px;
                font-weight: 500;
                color: #000;
                line-height: 16px;
                margin-bottom: 20px;
            }

            .veui-field {
                margin: 18px 0;
                // height: 40px;
                .veui-input {
                    height: 40px;
                    width: 324px;
                    border: 1px solid rgba(233, 236, 243, 1);
                    border-radius: 8px;

                    .veui-input-input {
                        font-family: PingFangSC-Semibold;
                        font-weight: 600;
                        color: #1e1f24;
                    }
                }

                .veui-field-label {
                    justify-content: flex-start;
                    margin-right: 10px;
                    height: 40px;
                }

                .veui-select {
                    width: 324px;
                    height: 85px;

                    .veui-input {
                        height: 85px;
                    }
                }
            }

            .veui-form {
                .veui-field:nth-child(3) {
                    .veui-field-main {
                        .ivu-input {
                            font-family: PingFangSC-Semibold;
                            font-weight: 600;
                            color: #1e1f24;
                            width: 324px;
                        }

                        .ivu-input::placeholder {
                            font-family: "PingFang SC", "Microsoft Yahei", Arial, sans-serif;
                            color: rgba(80, 90, 107, .8);
                            font-weight: 400;
                        }

                        .ivu-input-wrapper:hover {
                            border: 1px solid #e9ecf3;
                        }
                    }
                }

                .veui-field:nth-child(5) {
                    height: 85px;

                    .veui-field-label {
                        position: relative;
                        top: -22px;
                        height: 85px;
                    }

                    .veui-field-main {
                        position: relative;

                        .veui-select-clear {
                            display: none;
                        }

                        .veui-select-placeholder {
                            position: relative;
                            top: -22px;
                        }

                        .veui-select-count {
                            position: absolute;
                            top: 56px;
                            right: 1px;
                        }

                        .veui-select-toggle {
                            position: absolute;
                            top: -33px;
                            right: 0;
                        }
                    }
                }

                .veui-field:nth-child(6) {
                    .veui-field-label {
                        padding-left: 10px;
                    }

                    .veui-field-main {
                        .ivu-upload-drag {
                            border-radius: 8px;
                        }
                    }
                }

                .veui-field:nth-child(10) {
                    .veui-field-label {
                        padding-left: 10px;
                    }

                    .veui-field-main {
                        .ivu-upload-drag {
                            border-radius: 8px;
                        }
                    }
                }
            }
        }

        .veui-dialog-content-foot {
            padding-top: 16px;

            .veui-button {
                width: 192px;
                height: 40px;
                margin-left: 248px;
            }
        }
    }
}

.relative-overlay {
    width: 150px;
    height: 80px;
    background: #fff;
    border-radius: 0 0 3px 0 4px 4px 4px;
    box-shadow: 0 3px 3px 0 rgba(215, 220, 233, .5);
    padding: 10px 5px;
    box-sizing: border-box;

    .title {
        font-size: 14px;
        color: #333;
        line-height: 22px;
        text-align: center;
        margin-bottom: 15px;
    }

    .overlay-foot {
        text-align: center;

        .veui-button {
            height: 24px;
            border-radius: 5px;
            padding: 0 8px;
            box-sizing: border-box;

            &:first-child {
                margin-right: 8px;
            }
        }
    }
}

</style>

<style lang="less">
.benefit-tool {
    .veui-tooltip-box {
        .veui-tooltip {
            font-size: 16px;
            padding: 18px;
        }
    }
}
</style>